export default __webpack_public_path__ + "static/media/FortyFiveJobs.47ae6f9af071126957b24ae492a7b048.webp";